import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let NoDataMixin = class NoDataMixin extends Vue {
    $_NoDataMixin_bookFlowNoData() {
        this.sentNotif(this.$i18n.t('ERRORS.CALENDAR.NO.DATA'));
        this.$router.push({ path: `/appointment/matmut/fetch-details` });
    }
};
NoDataMixin = __decorate([
    Component
], NoDataMixin);
export default NoDataMixin;
;
